import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React, { FC } from "react";

interface IControlledRadioButton {
  fieldName: string;
  label: string;
  mode?: string;
  options?: Array<{
    value: string;
    label: string;
  }>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ControlledRadioButton: FC<IControlledRadioButton> = ({ fieldName, label, mode, options, value, onChange }) => (
  <FormControl>
    <FormLabel>{label} </FormLabel>
    <RadioGroup row name={fieldName} id={fieldName} value={value} onChange={onChange}>
      <Stack sx={{ alignItems: "center", flexDirection: "row" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "15px", marginRight: "10px" }}></Typography>
        <Stack sx={{ flexDirection: "row", marginTop: "5px" }}>
          {options?.map((elem) => (
            <FormControlLabel
              key={elem.value}
              disabled={mode === "view"}
              value={elem.value}
              control={<Radio />}
              label={elem.label}
            />
          ))}
        </Stack>
      </Stack>
    </RadioGroup>
  </FormControl>
);

export { ControlledRadioButton, IControlledRadioButton };
